export default function nav() {

  $('#main').css('min-height', $(window).height() - $('#header').height() - $('#footer').height() - 100);
	
	$('#header .hamburger').on('click', function (e) {
		e.preventDefault();
		$( this ).toggleClass( 'is-active' );
		$( '.nav-container' ).toggleClass( 'active' );
  });

	// Social Popup Open
	$('.share-links a').on('click', function (e) {
		e.preventDefault();
		var link = $(this).attr('href');
		window.open(link, 'popupWindow', 'width=670,height=378,scrollbars=no');
});
  
}